export const REFERRAL_DATA = {
  friendsJoined: 5,
  link: 'https://t.me/sandrapay_bot?start=ALE-7K2P',
};
